import { useState } from 'react'
import './App.css'
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import NotFound from './pages/NotFound';
import AppointmentPage from './pages/AppointmentPage';
import Treatments from './pages/Treatments';
import Doctors from './pages/Doctors';

function App() {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<MainLayout />}>
					<Route index element={<HomePage />} />
					<Route path="/about" element={<AboutPage />} />
					<Route path="/contact" element={<ContactPage />} />
					<Route path="/appointment" element={<AppointmentPage />} />
					<Route path="/treatments" element={<Treatments />} />
					<Route path="/doctors" element={<Doctors />} />
					<Route path="*" element={<NotFound />} />
				</Route>
			</Routes>
		</Router>
	)
}

export default App
